export default __webpack_public_path__ + "static/media/brand_image.d7a53099.png";